import { defaultIconProps, IconProps } from './IconProps';

export const IconControlCenterOverviewSet: import('react').FC<IconProps> = ({ size, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 228 96" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <g filter="url(#filter0_i_1895_33795)">
      <ellipse
        cx="26.856"
        cy="27.0138"
        rx="26.856"
        ry="27.0138"
        transform="matrix(0.0973573 -0.995235 0.995376 0.0962091 168.389 80.2953)"
        fill="url(#paint0_radial_1895_33795)"
      />
    </g>
    <path
      d="M200.448 30.0384C214.97 31.4421 225.592 44.2805 224.181 58.7072C222.77 73.1339 209.858 83.6978 195.336 82.2941C180.814 80.8905 170.192 68.052 171.604 53.6253C173.015 39.1986 185.926 28.6348 200.448 30.0384Z"
      stroke="#99B8F7"
      strokeWidth="1.206"
    />
    <path
      d="M212.727 51.531L198.952 54.9375M198.952 54.9375L188.549 45.3388M198.952 54.9375L195.562 68.0193M210.304 63.8045L213.201 52.627C213.324 52.1552 213.385 51.9193 213.368 51.6905C213.352 51.4881 213.293 51.2906 213.193 51.1113C213.08 50.9086 212.897 50.7395 212.53 50.4013L203.473 42.0448C203.126 41.7245 202.952 41.5644 202.749 41.4671C202.57 41.3811 202.375 41.3312 202.176 41.3204C201.952 41.3082 201.722 41.365 201.262 41.4787L189.27 44.4444C188.785 44.5644 188.542 44.6245 188.345 44.7477C188.17 44.8567 188.022 45.001 187.91 45.1708C187.784 45.3629 187.723 45.5988 187.601 46.0706L184.704 57.2481C184.581 57.7199 184.52 57.9558 184.537 58.1846C184.553 58.387 184.612 58.5845 184.712 58.7638C184.825 58.9664 185.008 59.1356 185.375 59.4738L194.432 67.8303C194.779 68.1506 194.953 68.3107 195.155 68.4079C195.335 68.494 195.53 68.5439 195.729 68.5547C195.953 68.5669 196.183 68.51 196.643 68.3964L208.635 65.4307C209.12 65.3106 209.363 65.2506 209.56 65.1274C209.735 65.0184 209.883 64.8741 209.994 64.7042C210.121 64.5122 210.182 64.2763 210.304 63.8045Z"
      stroke="white"
      strokeWidth="2.412"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g filter="url(#filter1_i_1895_33795)">
      <ellipse
        cx="18.5322"
        cy="18.6288"
        rx="18.5322"
        ry="18.6288"
        transform="matrix(0.24974 -0.968278 0.96906 0.24696 134.281 36.2906)"
        fill="url(#paint1_radial_1895_33795)"
      />
    </g>
    <path
      d="M161.44 5.58636C171.09 8.04566 176.902 17.8134 174.43 27.3985C171.958 36.9836 162.134 42.7666 152.484 40.3073C142.834 37.848 137.022 28.0803 139.494 18.4952C141.966 8.91013 151.789 3.12706 161.44 5.58636Z"
      stroke="#99B8F7"
      strokeWidth="1.206"
    />
    <path
      d="M160.967 29.131L160.803 29.133C159.427 29.1492 158.738 29.1573 158.209 28.8972C157.744 28.6684 157.364 28.2991 157.123 27.8421C156.848 27.3227 156.84 26.6385 156.824 25.2702L156.762 20.0582C156.746 18.6899 156.737 18.0057 156.999 17.48C157.229 17.0175 157.601 16.6393 158.06 16.3996C158.583 16.1271 159.271 16.119 160.648 16.1028L160.812 16.1009M160.967 29.131C160.978 30.0306 161.72 30.7512 162.625 30.7405C163.53 30.7299 164.255 29.992 164.244 29.0924C164.233 28.1929 163.491 27.4723 162.586 27.483C161.681 27.4936 160.956 28.2315 160.967 29.131ZM160.812 16.1009C160.822 17.0004 161.565 17.721 162.47 17.7104C163.375 17.6997 164.1 16.9619 164.089 16.0623C164.078 15.1628 163.336 14.4422 162.431 14.4528C161.526 14.4635 160.801 15.2013 160.812 16.1009ZM152.696 22.7124L160.889 22.616M152.696 22.7124C152.707 23.612 151.982 24.3498 151.077 24.3605C150.172 24.3711 149.43 23.6506 149.419 22.751C149.409 21.8515 150.134 21.1136 151.038 21.103C151.943 21.0923 152.686 21.8129 152.696 22.7124ZM160.889 22.616C160.9 23.5155 161.642 24.2361 162.547 24.2254C163.452 24.2148 164.177 23.4769 164.166 22.5774C164.156 21.6778 163.413 20.9572 162.508 20.9679C161.604 20.9786 160.879 21.7164 160.889 22.616Z"
      stroke="white"
      strokeWidth="1.206"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g filter="url(#filter2_i_1895_33795)">
      <ellipse
        cx="33.352"
        cy="33.5306"
        rx="33.352"
        ry="33.5306"
        transform="matrix(-0.246767 -0.969107 0.969748 -0.243984 16.6367 95.8236)"
        fill="url(#paint2_radial_1895_33795)"
      />
    </g>
    <path
      d="M32.8414 23.5837C50.4796 19.146 68.3918 29.7621 72.8543 47.2872C77.3167 64.8123 66.6424 82.6206 49.0042 87.0583C31.3659 91.496 13.4538 80.8799 8.99129 63.3548C4.52881 45.8297 15.2032 28.0214 32.8414 23.5837Z"
      stroke="#99B8F7"
      strokeWidth="1.206"
    />
    <g filter="url(#filter3_d_1895_33795)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.3012 39.8739C31.1545 39.582 32.0842 40.033 32.3779 40.8811L32.9096 42.4169L39.0895 40.3028L38.5578 38.7671C38.2642 37.919 38.7178 36.9948 39.5711 36.7029C40.4244 36.411 41.3541 36.8619 41.6478 37.7101L42.1803 39.2483C42.9166 39.0021 43.5639 38.7975 44.137 38.6521C45.0298 38.4256 45.8805 38.3038 46.7618 38.4271C48.1286 38.6183 49.3993 39.2346 50.392 40.1878C51.0321 40.8024 51.4591 41.5439 51.8289 42.3828C52.0663 42.9214 52.3024 43.5543 52.5603 44.2828L54.1078 43.7534C54.961 43.4615 55.8908 43.9125 56.1844 44.7607C56.4781 45.6088 56.0244 46.533 55.1711 46.8249L53.6262 47.3534L55.2212 51.9606L56.7662 51.4321C57.6195 51.1402 58.5492 51.5911 58.8429 52.4393C59.1365 53.2875 58.6829 54.2117 57.8296 54.5035L56.2846 55.0321L56.4129 55.4027C56.8409 56.6389 57.1942 57.6591 57.4136 58.5136C57.6415 59.4011 57.764 60.2467 57.64 61.1228C57.4476 62.4813 56.8276 63.7445 55.8687 64.7312C55.2503 65.3675 54.5044 65.7919 53.6604 66.1595C53.1186 66.3955 52.4819 66.6302 51.749 66.8865L52.2816 68.4247C52.5752 69.2729 52.1215 70.1971 51.2683 70.489C50.415 70.7808 49.4853 70.3299 49.1916 69.4817L48.6599 67.946L42.48 70.06L43.0117 71.5958C43.3053 72.4439 42.8517 73.3681 41.9984 73.66C41.1451 73.9519 40.2154 73.5009 39.9217 72.6528L39.3892 71.1146C38.6529 71.3608 38.0056 71.5654 37.4325 71.7108C36.5397 71.9373 35.689 72.059 34.8077 71.9358C33.4409 71.7446 32.1702 71.1283 31.1775 70.1751C30.5374 69.5604 30.1104 68.819 29.7406 67.98C29.3845 67.1723 29.0313 66.152 28.6033 64.9158L28.475 64.5452L26.93 65.0737C26.0768 65.3656 25.147 64.9147 24.8534 64.0665C24.5597 63.2183 25.0134 62.2941 25.8667 62.0023L27.4116 61.4737L25.8166 56.8666L24.2716 57.3951C23.4183 57.6869 22.4886 57.236 22.1949 56.3878C21.9013 55.5397 22.3549 54.6155 23.2082 54.3236L24.7557 53.7942C24.508 53.0623 24.3022 52.419 24.1559 51.8493C23.928 50.9618 23.8055 50.1162 23.9295 49.2401C24.1219 47.8816 24.7419 46.6184 25.7008 45.6317C26.3192 44.9954 27.0651 44.571 27.9091 44.2034C28.4508 43.9674 29.0876 43.7327 29.8205 43.4764L29.2879 41.9382C28.9943 41.09 29.448 40.1658 30.3012 39.8739ZM32.119 46.1225C30.7956 46.5753 29.8964 46.8842 29.2206 47.1785C28.5623 47.4653 28.2504 47.6835 28.0511 47.8885C27.5717 48.3819 27.2616 49.0134 27.1655 49.6927C27.1255 49.975 27.1444 50.3537 27.3222 51.0459C27.5047 51.7565 27.8131 52.6512 28.2685 53.9667L31.6713 63.7953C32.1268 65.1108 32.4376 66.0047 32.7337 66.6764C33.0221 67.3308 33.2416 67.6408 33.4479 67.8389C33.9442 68.3155 34.5796 68.6236 35.263 68.7192C35.547 68.7589 35.9279 68.7401 36.6243 68.5634C37.3392 68.382 38.2393 68.0755 39.5627 67.6228L49.4505 64.2403C50.7739 63.7876 51.6731 63.4787 52.3489 63.1843C53.0072 62.8976 53.3191 62.6794 53.5184 62.4744C53.9978 61.981 54.3079 61.3494 54.404 60.6702C54.444 60.3879 54.4251 60.0092 54.2473 59.317C54.0648 58.6064 53.7564 57.7117 53.301 56.3962L49.8982 46.5675C49.4427 45.2521 49.1319 44.3582 48.8358 43.6865C48.5474 43.0321 48.3279 42.7221 48.1216 42.524C47.6253 42.0474 46.9899 41.7393 46.3065 41.6437C46.0225 41.604 45.6416 41.6227 44.9452 41.7994C44.2303 41.9808 43.3302 42.2874 42.0068 42.7401L32.119 46.1225ZM36.4457 49.7953L40.8702 48.2817C41.2601 48.1483 41.6399 48.0184 41.9705 47.9345C42.3336 47.8423 42.7738 47.7675 43.2667 47.8364C43.95 47.932 44.5854 48.2401 45.0817 48.7167C45.4397 49.0605 45.6512 49.4514 45.8016 49.7926C45.9386 50.1033 46.0692 50.4808 46.2033 50.8684L47.726 55.2664C47.8602 55.654 47.991 56.0314 48.0754 56.3601C48.168 56.721 48.2434 57.1586 48.174 57.6485C48.0779 58.3278 47.7678 58.9593 47.2884 59.4527C46.9426 59.8085 46.5493 60.0188 46.206 60.1683C45.8935 60.3044 45.5137 60.4343 45.1237 60.5676L40.6993 62.0811C40.3094 62.2146 39.9296 62.3445 39.599 62.4284C39.2359 62.5205 38.7957 62.5954 38.3028 62.5265C37.6195 62.4309 36.9841 62.1227 36.4878 61.6461C36.1298 61.3024 35.9183 60.9115 35.7679 60.5703C35.6309 60.2596 35.5003 59.8821 35.3662 59.4945L33.8435 55.0965C33.7093 54.7089 33.5785 54.3314 33.4941 54.0028C33.4015 53.6418 33.3261 53.2043 33.3955 52.7144C33.4916 52.0351 33.8017 51.4035 34.2811 50.9102C34.6269 50.5543 35.0202 50.3441 35.3635 50.1946C35.676 50.0585 36.0558 49.9286 36.4457 49.7953ZM36.6552 53.1785C36.6568 53.1851 36.6585 53.1921 36.6604 53.1994C36.7077 53.3835 36.7928 53.633 36.9504 54.0884L38.4392 58.3885C38.5968 58.8439 38.6843 59.0926 38.761 59.2666C38.7641 59.2736 38.767 59.2801 38.7698 59.2863C38.7764 59.2847 38.7834 59.2829 38.7908 59.2811C38.9759 59.2341 39.227 59.1495 39.6852 58.9928L44.0111 57.513C44.4692 57.3563 44.7195 57.2693 44.8945 57.1931C44.9015 57.19 44.9081 57.1871 44.9143 57.1844C44.9127 57.1778 44.9109 57.1708 44.9091 57.1635C44.8618 56.9794 44.7767 56.7298 44.6191 56.2744L43.1303 51.9744C42.9727 51.519 42.8852 51.2702 42.8085 51.0962C42.8054 51.0893 42.8025 51.0828 42.7997 51.0766C42.7931 51.0782 42.7861 51.0799 42.7787 51.0818C42.5936 51.1288 42.3425 51.2133 41.8843 51.3701L37.5584 52.8499C37.1003 53.0066 36.85 53.0936 36.675 53.1698C36.668 53.1728 36.6614 53.1757 36.6552 53.1785Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_1895_33795"
        x="170.875"
        y="29.3103"
        width="54.0352"
        height="53.7119"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="4.82399" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1895_33795" />
      </filter>
      <filter
        id="filter1_i_1895_33795"
        x="138.32"
        y="4.41766"
        width="37.2832"
        height="37.0584"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="4.82399" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1895_33795" />
      </filter>
      <filter
        id="filter2_i_1895_33795"
        x="7.37305"
        y="21.9721"
        width="67.0996"
        height="66.6978"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="4.82399" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1895_33795" />
      </filter>
      <filter
        id="filter3_d_1895_33795"
        x="17.1605"
        y="31.6691"
        width="46.7161"
        height="47.0247"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="2.47247" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.6 0 0 0 0 0.721569 0 0 0 0 0.968627 0 0 0 0.9 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1895_33795" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1895_33795" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_1895_33795"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-31.0618 23.5053) rotate(14.7624) scale(100.299 90.0211)"
      >
        <stop offset="0.42" stopColor="#6695F3" />
        <stop offset="1" stopColor="#D9E4FF" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_1895_33795"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-21.4345 16.2093) rotate(14.753) scale(69.2096 62.0813)"
      >
        <stop offset="0.42" stopColor="#6695F3" />
        <stop offset="1" stopColor="#D9E4FF" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_1895_33795"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-38.5752 29.1757) rotate(14.755) scale(124.556 111.741)"
      >
        <stop offset="0.42" stopColor="#6695F3" />
        <stop offset="1" stopColor="#D9E4FF" />
      </radialGradient>
    </defs>
  </svg>
);

IconControlCenterOverviewSet.defaultProps = defaultIconProps;
